import { Pipe, PipeTransform } from '@angular/core';
import { routeToMenuMapping } from '@app/config';

import { IMenuElement } from '@interfaces/menu.interface';

@Pipe({
  name: 'getRoutePath',
})
export class GetRoutePathPipe implements PipeTransform {
  transform(menuElement: IMenuElement): string {
    return `${menuElement.module}/${(routeToMenuMapping as unknown as { [key: string]: number })[menuElement.label]}`;
  }
}
